function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { BigNumber } from "bignumber.js";
import sortBy from "lodash/sortBy";
import zipObject from "lodash/zipObject";
import { getFullScope } from "./getFullScope";
import { lookup } from "./lookup";
import { roundNumber } from "./roundNumber";
import { inferType } from "./inferType";
const DECIMAL_UNITS = {
  "0": "unit",
  "1": "ten",
  "2": "hundred",
  "3": "thousand",
  "6": "million",
  "9": "billion",
  "12": "trillion",
  "15": "quadrillion",
  "-1": "deci",
  "-2": "centi",
  "-3": "mili",
  "-6": "micro",
  "-9": "nano",
  "-12": "pico",
  "-15": "femto"
};
const INVERTED_DECIMAL_UNITS = zipObject(Object.values(DECIMAL_UNITS), Object.keys(DECIMAL_UNITS).map(key => parseInt(key, 10)));
export function numberToHuman(i18n, input, options) {
  const roundOptions = {
    roundMode: options.roundMode,
    precision: options.precision,
    significant: options.significant
  };
  let units;
  if (inferType(options.units) === "string") {
    const scope = options.units;
    units = lookup(i18n, scope);
    if (!units) {
      throw new Error(`The scope "${i18n.locale}${i18n.defaultSeparator}${getFullScope(i18n, scope, {})}" couldn't be found`);
    }
  } else {
    units = options.units;
  }
  let formattedNumber = roundNumber(new BigNumber(input), roundOptions);
  const unitExponents = units => sortBy(Object.keys(units).map(name => INVERTED_DECIMAL_UNITS[name]), numeric => numeric * -1);
  const calculateExponent = (num, units) => {
    const exponent = num.isZero() ? 0 : Math.floor(Math.log10(num.abs().toNumber()));
    return unitExponents(units).find(exp => exponent >= exp) || 0;
  };
  const determineUnit = (units, exponent) => {
    const expName = DECIMAL_UNITS[exponent.toString()];
    return units[expName] || "";
  };
  const exponent = calculateExponent(new BigNumber(formattedNumber), units);
  const unit = determineUnit(units, exponent);
  formattedNumber = roundNumber(new BigNumber(formattedNumber).div(Math.pow(10, exponent)), roundOptions);
  if (options.stripInsignificantZeros) {
    let _formattedNumber$spli = formattedNumber.split("."),
      _formattedNumber$spli2 = _slicedToArray(_formattedNumber$spli, 2),
      whole = _formattedNumber$spli2[0],
      significand = _formattedNumber$spli2[1];
    significand = (significand || "").replace(/0+$/, "");
    formattedNumber = whole;
    if (significand) {
      formattedNumber += `${options.separator}${significand}`;
    }
  }
  return options.format.replace("%n", formattedNumber || "0").replace("%u", unit).trim();
}